define(['angular'], function(angular) {
    function X3Service($http, devance) {
        var self = this;
        self.backUrl = devance.getBdcUrl();

        self.updatePos = function(params) {
            // Modèle BPCDVLX2
            return $http.post(self.backUrl + 'x3/pos/import/BPCDVLX2', params)
                .then(res => {
                    return res.data;
                });
        };

        self.createMandate = function(params) {
            // Modèle ZMDT
            return $http.post(self.backUrl + 'x3/mandate/import/ZMDT', params)
                .then(res => {
                    return res.data;
                });
        };

        return self;
    }

    X3Service.$inject = [
        '$http', 'devance'
    ];

    angular.module('app.devance.movements.x3Service', [])
        .factory('x3Service', X3Service);
});
